module.exports = "<label class=inp-single> {{ label }} {{fragment}} <input type=text v-model=model :placeholder=label> </label>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputSingle.vue
 ** module id = 136
 ** module chunks = 0
 **/